import { reactive } from 'vue'

const toasts = reactive([])
let toastIdCounter = 0

const DEFAULT_DURATION = 3500

export const toastService = {
  show: (message, type = 'info', duration = DEFAULT_DURATION) => {
    const id = ++toastIdCounter
    
    const toast = {
      id,
      message,
      subtitle: '',
      type,
      duration
    }
    
    toasts.push(toast)
    
    if (duration > 0) {
      setTimeout(() => {
        toastService.remove(id)
      }, duration)
    }
    
    return id
  },

  success: (message, duration = DEFAULT_DURATION) => {
    return toastService.show(message, 'success', duration)
  },

  error: (message, duration = DEFAULT_DURATION) => {
    return toastService.show(message, 'error', duration)
  },

  warning: (message, duration = DEFAULT_DURATION) => {
    return toastService.show(message, 'warning', duration)
  },

  info: (message, duration = DEFAULT_DURATION) => {
    return toastService.show(message, 'info', duration)
  },

  remove: (id) => {
    const index = toasts.findIndex(t => t.id === id)
    if (index > -1) {
      toasts.splice(index, 1)
    }
  },

  clear: () => {
    toasts.length = 0
  },

  getToasts: () => {
    return toasts
  }
}
